import React from 'react';
import { IconProps } from './model/IconInterface';

const FolderIcon: React.FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24'
       fill='none' stroke={color}
       strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4 20h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-7.6l-1.7-2.3a1 1 0 0 0-.8-.4H4a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1Z' />
  </svg>
);

export default FolderIcon;
